import type { ComponentProps } from "react"
import { TextareaField } from "@holigral/shared/ui/composed"
import FormControl from "./FormControl"

export type Props = ComponentProps<typeof TextareaField> & {
  name: string
}

export default function FormTextarea({
  name,
  required,
  onChange,
  ...rest
}: Props) {
  return (
    <FormControl name={name} required={required}>
      {({ field, isError, error }) => (
        <TextareaField
          id={name}
          required={required}
          aria-invalid={isError}
          error={error}
          {...field}
          name={name}
          {...rest}
          onChange={(e) => {
            field.onChange(e)
            onChange?.(e)
          }}
        />
      )}
    </FormControl>
  )
}
